import { Component, Input } from '@angular/core';
import { SurchargeResponse } from '../../../../api';

@Component({
  selector: 'base-surcharges',
  templateUrl: './base-surcharges.component.html',
})
export class BaseSurchargesComponent {
  @Input() surcharges: SurchargeResponse[] = [];
  @Input() hideHeaders = false;
}
